/// <reference path="../include.ts" />

namespace project_guide {

	import Region = project_common.Region;
	import Area = project_common.Area;
	import Zone = project_common.Zone;
	import Species = project_common.Species;
	import Application = project_common.Application;

	export class LinneLensGuide extends Application {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implSetupView():void {
			this.initSpecies = null;

			this.drawerContent = DrawerContent.getInstance();
			this.drawerContent.addEventListener(DrawerContentEvent.requireGotoScene, this.drawerContentRequireTransferHandler);
			this.drawerContent.ready();
			this.drawerContent.setContext();
			this.drawerContent.show(false);

			this.header = Header.getInstance();
			this.header.ready();
			this.header.setContext();
			this.header.show(false);

			this.introduction = Introduction.getInstance();
			this.introduction.ready();
			this.introduction.setContext();
			this.introduction.show(false);

			this.bannerContainer = BannerContainer.getInstance();
			this.bannerContainer.ready();
			this.bannerContainer.setContext();
			this.bannerContainer.show(false);

			this.listView = ListView.getInstance();
			this.listView.addEventListener(ListViewEvent.requireGotoScene, this.listViewRequireTransferHandler);
			this.listView.ready();
			this.listView.setContext();
			this.listView.show(false);

			this.cardView = CardView.getInstance();
			this.cardView.addEventListener(CardViewEvent.requireClose, this.cardViewRequireCloseHandler);
			this.cardView.ready();
		}

		protected implApplyScene(region:Region, area:Area, zone:Zone, species:Species, useTransition:boolean):void {
			//let viewType:ViewType;
			//if (Config.zoneViewType === ViewType.list) {
			//	viewType = species ? ViewType.card : ViewType.list;
			//} else {
			//	viewType = (species || zone) ? ViewType.card : ViewType.list;
			//}
			const viewType = (species || zone) ? ViewType.card : ViewType.list;

			if (viewType === ViewType.card) {
				// card view
				trace('[Application] show card view');

				if (species) {
					trace('[Application] goto species :', species.urn);
					if (Application.getIsInitializing()) {
						trace('[Application] save init species');
						this.initSpecies = species;
					}
				}

				this.listView.saveScrollPosition();
				this.cardView.setContext(region, area, zone, species);
				if (this.cardView.getIsShown()) {
					if (species) {
						this.cardView.scrollToSpecies(species, useTransition);
					}
				} else {
					this.cardView.show(useTransition);
				}

			} else {
				// list view
				trace('[Application] show list view');
				this.cardView.hide(useTransition);

				if (zone) {
					trace('[Application] goto zone :', zone.urn);
					this.listView.scrollToZone(zone, useTransition);

				} else if (area) {
					trace('[Application] goto area :', area.urn);
					this.listView.scrollToArea(area, useTransition);

				} else if (region) {
					trace('[Application] goto region :', region.urn);
					this.listView.scrollToRegion(region, useTransition);

				} else if (this.initSpecies) {
					// if initial view was card view (species specified), scrolling list to species when closed card view by close button.
					trace('[Application] goto init species :', this.initSpecies);
					const species = this.initSpecies;
					this.initSpecies = null;
					this.listView.scrollToSpecies(species, false);

				} else {
					trace('[Application] goto top');
					this.listView.scrollToTop(useTransition);
				}
			}
		}





		private drawerContentRequireTransferHandler = (event:DrawerContentEvent):void => {
			this.applyScene(event.region, event.area, null, null);
		};

		private listViewRequireTransferHandler = (event:ListViewEvent):void => {
			this.applyScene(event.region, event.area, event.zone, event.species);
		};

		private cardViewRequireCloseHandler = (event:CardViewEvent):void => {
			this.cardView.hide();
			this.listView.loadScrollPosition();
		};





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private drawerContent:DrawerContent;
		private header:Header;
		private introduction:Introduction;
		private bannerContainer:BannerContainer;
		private listView:ListView;
		private cardView:CardView;

		private initSpecies:Species;
	}
}
